// extracted by css-extract-rspack-plugin
export default {"Root":"sputnik__Root__GhSpR","root":"sputnik__Root__GhSpR"};